import { useSize } from '@spikemark/shared-hooks';
import { FC, PropsWithChildren, useRef } from 'react';
import { LoadingSpinner } from './loading-spinner';
import { cn } from '../utils/cn';
export const ExpandableComponentContainer: FC<PropsWithChildren<{
  expanded?: boolean;
  isLoading?: boolean;
}>> = ({
  children,
  expanded,
  isLoading
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const size = useSize(ref);
  return <div ref={containerRef} className={cn('duration-500 ease-expo-out overflow-hidden w-full max-w-screen', {
    'opacity-60': !expanded
  })} style={{
    transitionProperty: 'opacity, height',
    height: expanded ? size.height : 0
  }} data-sentry-component="ExpandableComponentContainer" data-sentry-source-file="expandable-content-container.tsx">
      {isLoading && <div className="flex items-center justify-center">
          <LoadingSpinner />
        </div>}
      <div ref={ref} className={cn('transition-all duration-500 ease-expo-out w-full max-w-screen', {
      'opacity-0 -translate-y-10 pointer-events-none': !expanded
    })}>
        {children}
      </div>
    </div>;
};